import { Icon } from '@chakra-ui/react';
import RDatePicker from 'react-date-picker';
import { BiCalendar, BiX } from 'react-icons/bi';

import { UI_DATE_FORMAT } from '../utils/dateUtils';

type DateOrNull = Date | null;
export const DatePicker = ({
    value,
    onChange,
    maxDate,
    minDate,
}: {
    value?: string | Date;
    onChange: (value: DateOrNull | [DateOrNull, DateOrNull]) => void;
    maxDate?: Date;
    minDate?: Date;
}) => {
    return (
        <RDatePicker
            format={UI_DATE_FORMAT}
            onChange={onChange}
            value={value}
            clearIcon={<Icon as={BiX} />}
            calendarIcon={<Icon as={BiCalendar} />}
            shouldCloseCalendar={() => true}
            maxDate={maxDate}
            minDate={minDate}
        />
    );
};
